import { render, staticRenderFns } from "./ActionEditor.vue?vue&type=template&id=f0646fba"
import script from "./ActionEditor.vue?vue&type=script&lang=ts"
export * from "./ActionEditor.vue?vue&type=script&lang=ts"
import style0 from "./ActionEditor.vue?vue&type=style&index=0&id=f0646fba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports